<template lang="pug">
div
	.loggedin
		.sidenav
			transition(name="sidenav-fade")
				.sidenav__backdrop(v-if="sideNavIsOpen")
			.sidenav__toggle.hide-desktop
				.md-sidenav-left(md-component-id="left", md-disable-scroll-target="body", v-if="sideNavIsOpen")
					.sidenav-toolbar
						a.sidenav-toolbar__close.icon-close(@click="collapseMobile")
						a.sidenav-toolbar__logo.icon-otp-ip-logo(href='/fooldal')
					.sidenav-content
						slot(name="sidenav-content", :user-info="userInfo", :is-logged-in="isLoggedIn", :full-name="fullName", :open-login-form="openLoginForm")
		section.header-bar.section.section--green.hide-desktop
			.section__container.section__container--nopadding
				.header-toolbar
					a.header-toolbar__menu.icon-menu(@click='collapseMobile')
					a.header-toolbar__logo.icon-otp-ip-logo(href='/fooldal')
					a.header-toolbar__favorite.icon-favorite(href='/kedvencek')
					button.header-search__button.icon-search(type='button', onclick='window.scrollTo(0, 0)') Keresés
		section.section.section--green.hide-mobile
			.section__container.section__container--nopadding
				.header-top
					slot(name="header-top",:is-logged-in="isLoggedIn", :user-info="userInfo", :open-login-form="openLoginForm")
		section.section.section--header-nav.hide-mobile
			.section__container.section__container--nopadding
				.header-bottom
					slot(name="header-bottom", :logout="logout")
					ul.header-options(v-if="isLoggedIn")
						li.header-options__item.header-options__item--logout
							a.header-options__item-link(href="#" @click="logout") {{$t('FRAME.logout')}}
				p.header-welcome(v-if="isLoggedIn && fullName") {{$t('FRAME.welcome')}} {{fullName}}!
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import eventBus from '../../common/js/event-bus/event-bus';
export default {
	data: () => ({
		sideNavIsOpen: false,
		layoutId: window.layoutId
	}),
	computed: {
		...mapState('auth', ['userInfo']),
		...mapGetters('auth', ['fullName', 'isLoggedIn'])
	},
	methods: {
		openLoginForm(e) {
			window.ipEventBus.publish('open-login-form', e);
		},
		logout() {
			window.ipEventBus.publish('logout');
		},
		checkCookies() {
			if (this.$cookies.get('logout') == 'success') {
				this.$cookies.remove('logout', null);
				window.ipEventBus.publish('show-info', {
					message: 'logoutSuccessNotification'
				});
			}
			if (this.$cookies.get('login') == 'loginSuccessRegistrationSuccess') {
				this.$cookies.remove('login', null);
				window.ipEventBus.publish('show-info', {
					message: 'loginSuccessRegistrationSuccess'
				});
			}
			if (this.$cookies.get('login') == 'loginSuccess') {
				this.$cookies.remove('login', null);
				window.ipEventBus.publish('show-info', {
					message: 'loginSuccess'
				});
			}
		},

		collapseMobile() {
			this.sideNavIsOpen = !this.sideNavIsOpen;
			eventBus.$emit('sidenav-toggle', this.sideNavIsOpen);
		}
	},
	mounted() {
		this.checkCookies();
	}
};
</script>
